import { useMutation } from '@tanstack/react-query';
import { checkoutIntentsClient } from 'app/checkout-intents/client';

const triggerTestEvent = async (productUrl: string): Promise<void> => {
  const client = checkoutIntentsClient.get();
  if (!client) {
    throw new Error('API client not initialized');
  }

  await client.post('/api/v1/events/trigger', {
    body: { topic: 'product.updated', productUrl },
  });
};

export const useTriggerTestEvent = () => useMutation({ mutationFn: triggerTestEvent });
